import { useMemo } from 'react';
import { FormattedStep } from './useStepIndicator';

export type StepIndicatorClassNames = {
  circle: string;
};

export type StepIndicatorStepHook = {
  classNames: StepIndicatorClassNames;
  hasExpansions: boolean;
  showExpand: boolean;
};

const getCircleClassName = (
  isActive: boolean,
  isPassed: boolean,
  final: boolean,
): string => {
  if (isActive && final) return 'bg-purple-300';
  if (isActive) return 'bg-neutral-900';
  if (isPassed) return 'bg-purple-300';
  return 'bg-neutral-500';
};

export default function useStepIndicatorStep(
  step: FormattedStep,
): StepIndicatorStepHook {
  const { isActive, isPassed, expand, expansions, final = false } = step;

  const classNames = useMemo(
    () => ({
      circle: [
        'flex w-6 min-w-6 h-6 min-h-6 rounded-full m-auto',
        getCircleClassName(isActive, isPassed, final),
      ].join(' '),
    }),
    [isActive, isPassed, final],
  );

  const hasExpansions = useMemo(
    () => Boolean(expansions && expansions.length > 0),
    [expansions],
  );

  const showExpand = useMemo(
    () => Boolean(isActive && expand && expansions && expansions.length > 0),
    [isActive, expand, expansions],
  );

  return {
    classNames,
    hasExpansions,
    showExpand,
  };
}
